import { metaAccount } from '@/router/meta-config'
const permissionKey = 'ROLE'

export default [
  // roles
  {
    path: '/roles',
    name: 'page-roles',
    component: () => import('@/pages/roles'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/role/new',
    name: 'page-role-new',
    component: () => import('@/pages/role'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/role/:id',
    name: 'page-role',
    component: () => import('@/pages/role'),
    props: (role) => ({ id: role.params.id }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
